module.exports = __webpack_public_path__ + "img/step4.eea2817d.png";